var siteConfig = {
  domain: "griko.id",
  siteUrl: "https://griko.id",
  dashboardUrl: "https://datocms.griko.id"
};
module.exports = siteConfig;